<template>
  <div>
    <div class="breadCrumb">
      <div><h3>Création Configuration</h3></div>
      <div>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Paramètres</li>
            <li class="breadcrumb-item">Configuration</li>
            <li class="breadcrumb-item active" aria-current="page">Création</li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="card p-3">
      
      <div class="row p-2">
        <div class="col-md-6 mb-3">
          <label for="nomClinique" class="form-label">Nom de la clinique</label>
          <input
            type="text"
            id="nomClinique"
            v-model="form.nomClinique"
            class="form-control"
            :class="{ 'is-invalid': errors.nomClinique }"
            placeholder="Ex: Clinique Zantigui GWE"
          />
          <div class="invalid-feedback">{{ errors.nomClinique }}</div>
        </div>
        <div class="col-md-6 mb-3">
    <label for="villeClinique" class="form-label">Ville</label>
    <input
      type="text"
      id="villeClinique"
      v-model="form.villeClinique"
      class="form-control"
      :class="{ 'is-invalid': errors.villeClinique }"
      placeholder="Ex: Bamako"
    />
    <div class="invalid-feedback">{{ errors.villeClinique }}</div>
  </div>

        <div class="col-md-6 mb-3">
          <label for="telephone" class="form-label">Téléphone</label>
          <input
            type="text"
            id="telephone"
            v-model="form.telephone"
            class="form-control"
            :class="{ 'is-invalid': errors.telephone }"
            placeholder="Ex: +223 70 00 00 00"
          />
          <div class="invalid-feedback">{{ errors.telephone }}</div>
        </div>
      </div>

      <div class="row p-2">
        <div class="col-md-6 mb-3">
          <label for="adresse" class="form-label">Adresse</label>
          <input
            type="text"
            id="adresse"
            v-model="form.adresse"
            class="form-control"
            :class="{ 'is-invalid': errors.adresse }"
            placeholder="Ex: ACI 2000 Bamako"
          />
          <div class="invalid-feedback">{{ errors.adresse }}</div>
        </div>

        <div class="col-md-6 mb-3">
  <label for="logo" class="form-label">Logo (fichier)</label>
  <input
    type="file"
    id="logo"
    class="form-control"
    @change="handleFileUpload"
    accept="image/*"
  />
</div>
      </div>

      <div class="row p-2">
        <div class="col-md-12 mb-3">
          <label for="description" class="form-label">Description</label>
          <textarea
            id="description"
            v-model="form.description"
            class="form-control"
            rows="3"
            placeholder="Brève description de la clinique"
          ></textarea>
        </div>
      </div>

      <div class="d-flex justify-content-between mt-3 px-2">
        <button class="btn btn-danger" @click="cancel">Annuler</button>
        <button
  class="btn btn-success d-flex align-items-center"
  @click="saveConfiguration"
  :disabled="loading"
>
  <span
    v-if="loading"
    class="spinner-border spinner-border-sm me-2"
    role="status"
  ></span>

  {{ loading ? 'Enregistrement...' : 'Enregistrer' }}
</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import Multiselect from '@vueform/multiselect'

export default {
  name: 'CreateConfiguration',
  
  data() {
    return {
      logoFile: null,
       loading: false,
      form: {
        nomClinique: '',
        villeClinique: '',
        adresse: '',
        telephone: '',
        description: '',
        logo: ''
      },
      errors: {}
    };
  },
  methods: {
    validateForm() {
      this.errors = {
        nomClinique: this.form.nomClinique ? '' : 'Le nom est requis',
        villeClinique: this.form.villeClinique ? '' : 'La ville est requise',
        adresse: this.form.adresse ? '' : 'L\'adresse est requise',
        telephone: this.form.telephone ? '' : 'Le téléphone est requis',
      };
      return !Object.values(this.errors).some(msg => msg !== '');
    },
    async saveConfiguration() {
  if (!this.validateForm()) return;
   this.loading = true;

  try {
    const formData = new FormData();
    formData.append('nom', this.form.nomClinique);
    formData.append('ville', this.form.villeClinique);
    formData.append('adresse', this.form.adresse);
    formData.append('telephone', this.form.telephone);
    formData.append('description', this.form.description);
    if (this.logoFile) {
      formData.append('logoFile', this.logoFile); // correspond au nom du champ attendu côté API
    }

    //console.log(formData);

    await api.createItem('configurations', formData, true); 
   // alert('Configuration enregistrée avec succès !');
    this.$router.push({ name: 'item_config' });
  } catch (error) {
    console.error('Erreur lors de la création :', error);
    alert("Une erreur s'est produite");
  } finally {

    this.loading = false;

  }
},

    cancel() {
      this.$router.push({ name: 'item_config' });
    },
    handleFileUpload(event) {
    const file = event.target.files[0];
    if (file) {
     this.logoFile = file;
    }
},
  }
};
</script>

<style scoped>
.breadCrumb {
  display: flex;
  justify-content: space-between;
  padding: 8px;
}
</style>
